import "../styles/link-expired.scss";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import { useUpdateState } from "../utilities/utilities";
import { Spinner } from "../components/loading-spinner";
import { ToastContainer } from "../components/toast";
import { ZendeskSupportUrl } from "../utilities/constants";

export default function LinkExpired() {
  let { resetUsername } = useSelector((store) => store.user);
  let [state, update] = useUpdateState({ resendStatus: null, requesting: false });
  const { resendStatus, requesting } = state;

  useEffect(() => {
    if (resetUsername) loadResendStatus();
  }, [resetUsername]);

  async function loadResendStatus() {
    const result = await actions.passwordRecovery.getResendStatus(resetUsername);
    if (result?.success) update({ resendStatus: result });
  }

  async function requestNewLink() {
    if (requesting || !resetUsername) return;
    update({ requesting: true });
    try {
      await actions.passwordRecovery.forgot(resetUsername, {
        showSuccessToast: true,
        successToastMessage: "New reset link sent. Please check your inbox.",
        useGlobalLoading: false,
      });
      await loadResendStatus();
    } finally {
      update({ requesting: false });
    }
  }

  const resendExhausted = resendStatus
    ? resendStatus.resendCount >= resendStatus.maxResendsPerDay
    : false;

  return (
    <div className="login-shell link-expired-shell">
      <div className="login-brand link-expired-brand">
        <img src="/lib/images/Vector.svg" alt="High Ground Solutions" />
        <div className="login-brand-caption">High Ground Solutions</div>
      </div>

      <div className="login-screen sign-in-screen link-expired-screen">
        <div className="link-expired-icon">
          <i className="far fa-clock"></i>
        </div>

        <h2>Reset Link Expired</h2>
        <p className="link-expired-lead">
          Your password reset code has expired.
          <br />
          Please choose an option below.
        </p>

        <div className="link-expired-actions">
          <button
            type="button"
            className="link-expired-btn link-expired-btn--secondary"
            onClick={() => actions.passwordRecovery.changeScreen("forgotPassword")}
            disabled={resendExhausted}
          >
            <i className="far fa-chevron-left"></i>
            Back to Reset Password
          </button>

          <button
            type="button"
            className="link-expired-btn link-expired-btn--primary"
            onClick={requestNewLink}
            disabled={requesting || resendExhausted}
          >
            {requesting ? <Spinner /> : "Request New Link"}
          </button>

          {resendExhausted && (
            <p className="link-expired-limit-msg">
              Maximum resend limit reached.
            </p>
          )}

          <a
            className="support-link link-expired-support"
            href={ZendeskSupportUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Support
          </a>
        </div>

        <ToastContainer />
      </div>
    </div>
  );
}
